'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.isComponent = isComponent;
exports.isHostComponent = isHostComponent;
exports.isClassComponent = isClassComponent;
exports.isFunctionComponent = isFunctionComponent;
exports.getComponentDisplayName = getComponentDisplayName;
/**
 * @copyright 2015, Prometheus Research, LLC
 */

/**
 * Loose check if the argument is a valid React component.
 */
function isComponent(obj) {
  var typeofObj = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
  return typeofObj === 'string' || typeofObj === 'function';
}

/**
 * Check if the argument is a host React component.
 */
function isHostComponent(obj) {
  var typeofObj = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
  return typeofObj === 'string';
}

function isClassComponent(obj) {
  return isComponent(obj) && obj.prototype && obj.prototype.isReactComponent;
}

function isFunctionComponent(obj) {
  return isComponent(obj) && !isClassComponent(obj) && typeof obj === 'function';
}

/**
 * Get component display name.
 */
function getComponentDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  } else if (Component) {
    return Component.displayName || Component.name || null;
  } else {
    return null;
  }
}
